<div class="footer">
    <br/>
    <p>
        This website is created by
        <a href="https://issacto.com" style="color:rgba(27, 238, 115, 0.5);">
            Issac To
            
        </a>
        and the data is provided by 
        <a href="https://www.kaggle.com/CooperUnion/anime-recommendations-database" style="color:rgba(17, 192, 90, 0.5);">
            Kaggle
        </a>
    </p>
</div>